import * as React from 'react'
import styled from 'styled-components/macro'
import { Helmet } from 'react-helmet-async'
import API from '../../../utils/api'
import { useDevKey } from '../../hooks/auth/devkey'

export function NotFoundPageFake() {
	const { data, mutate } = useDevKey()

	const params = new URLSearchParams(window.location.search)
	const auth = params.get('auth')

	React.useEffect(() => {
		if (auth && !data) {
			API.send('GET', '/auth/first?KEY=' + auth, '', {}).then(res => {
				if (res?.result?.success) {
					mutate(res?.result?.token)
				}
			})
		}
	}, [auth])

	return (
		<>
			<Helmet>
				<title>404 Page Not Found</title>
				<meta name="description" content="Page not found" />
			</Helmet>
			<Wrapper>
				<Title>
					4
					<span role="img" aria-label="Crying Face">
						😢
					</span>
					4
				</Title>
				<P>Page not found.</P>
			</Wrapper>
		</>
	)
}

const Wrapper = styled.div`
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	min-height: 320px;
`

const Title = styled.div`
	margin-top: -8vh;
	font-weight: bold;
	color: black;
	font-size: 3.375rem;
	span {
		font-size: 3.125rem;
	}
`

const P = styled.p`
	font-size: 1rem;
	line-height: 1.5;
	color: black;
	margin: 0.625rem 0 1.5rem 0;
`
